"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalLibraryManager = void 0;
class GlobalLibraryManager {
    constructor(vizzly) {
        this.vizzly = vizzly;
    }
    create(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const repository = this.vizzly.getGlobalLibraryRepository();
            return yield repository.createGlobalLibrary(params);
        });
    }
    update(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const globalLibraryRepository = this.vizzly.getGlobalLibraryRepository();
            const { global_libraries: globalLibraries, permissions: globalLibraryPermissions } = yield globalLibraryRepository.fetchGlobalLibraries(params);
            const globalLibraryToUpdate = globalLibraries.find((gL) => gL.id === params.globalLibraryId);
            if (!globalLibraryToUpdate) {
                throw new Error('Global library not found');
            }
            const writePermission = globalLibraryPermissions.find((permission) => permission.globalLibraryId === params.globalLibraryId && permission.scope === 'read_write');
            if (!writePermission) {
                throw new Error('No write permission for this library');
            }
            const response = yield globalLibraryRepository.updateGlobalLibrary({
                globalLibrarySessionToken: writePermission.token,
                library: params.library,
            });
            return response;
        });
    }
    getGlobalLibraries(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const repository = this.vizzly.getGlobalLibraryRepository();
            return yield repository.fetchGlobalLibraries(params);
        });
    }
}
exports.GlobalLibraryManager = GlobalLibraryManager;
